import store from '@/state/store'
const fields = [
  {
    key: 'transitOn',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
    isSortable: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    isSortable: true,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
  },
  {
    key: 'geofence',
    label: 'report.report.geofence',
    header: 'geofence',
    filter: true,
    width: 10,
    isSortable: true,
  },
]
if (store.getters['identity/hasAccess'](['report_imei_column:read'])) {
  fields.splice(2, 0, {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: true,
    width: 20,
  })
}
export default fields
